import React from 'react';
import './index.less';

function Contact() {
  return (
    <div className="contact">
        <div className="container">
            <div className="row">
                <a title="twitter" className="contact-social twitter col-6 col-md-3" href="http://twitter.com/emrekilic87" target="_blank" rel="noopener noreferrer"> </a>
                <a title="linkedin" className="contact-social linkedin col-6 col-md-2" href="http://www.linkedin.com/in/emrekilic" target="_blank" rel="noopener noreferrer"> </a>
                <a title="superpeer" className="contact-social superpeer col-12 col-md-2" href="https://superpeer.com/emrekilic" target="_blank" rel="noopener noreferrer"> </a>
                <a title="github" className="contact-social github col-12 col-md-2" href="https://github.com/emrekilic87" target="_blank" rel="noopener noreferrer"> </a>
                <a title="emrekilic87@gmail.com" className="contact-social email col-12 col-md-3" href="mailto:emrekilic87@gmail.com" rel="noopener noreferrer"> </a>
            </div>
        </div>
    </div>
  );
}

export default Contact;